import { useAuth } from '@/contexto/AuthContexto';
import { Link } from 'react-router-dom';
import { Lock, Crown } from 'lucide-react';
import { Button } from '@/components/ui/button';

/**
 * FeatureGate — envuelve una ruta/página y valida que el plan del tenant tenga la feature.
 * Si no la tiene: muestra pantalla de "Función no incluida" con CTA a /suscripcion.
 * Si featuresPlan aún no cargó (null): renderiza los hijos (fail-open para evitar flash).
 * super_admin bypass total.
 */
export default function FeatureGate({ feature, children }) {
  const { usuario, featuresPlan } = useAuth();

  // Super admin siempre pasa
  if (usuario?.rol === 'super_admin') return children;

  // Features aún no cargaron o no hay lock configurado — dejar pasar
  if (!feature || featuresPlan === null) return children;

  // Tiene la feature — pasar
  if (featuresPlan.includes(feature)) return children;

  // No tiene la feature — bloquear con pantalla amable
  return (
    <div className="min-h-[70vh] flex items-center justify-center px-4">
      <div className="max-w-md w-full bg-slate-900 border border-slate-800 rounded-lg p-8 text-center" data-testid="feature-gate-blocked">
        <div className="w-14 h-14 rounded-full bg-amber-500/10 border border-amber-500/30 flex items-center justify-center mx-auto mb-4">
          <Lock className="w-6 h-6 text-amber-400" />
        </div>
        <h2 className="text-xl font-bold text-slate-100 mb-2">Función no incluida en tu plan</h2>
        <p className="text-sm text-slate-400 leading-relaxed mb-6">
          Esta herramienta no está activa en tu plan actual. Actualiza tu suscripción para desbloquearla.
        </p>
        <Link to="/suscripcion">
          <Button className="bg-amber-500 hover:bg-amber-600 text-black font-semibold" data-testid="feature-gate-upgrade-btn">
            <Crown className="w-4 h-4 mr-2" />
            Ver planes disponibles
          </Button>
        </Link>
      </div>
    </div>
  );
}
